import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
    selector: 'tran-base-button',
    imports: [],
    templateUrl: './base-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseButtonComponent {
    public readonly label = input.required<string>();
    public readonly clicked = output<void>();
}
